import { render, staticRenderFns } from "./mailinfo-info.vue?vue&type=template&id=0055b56a&"
import script from "./mailinfo-info.vue?vue&type=script&lang=js&"
export * from "./mailinfo-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mailinfo-info.vue"
export default component.exports